module.exports = __webpack_public_path__ + "img/map_dugout_lounge_tables.e2999aad.jpg";